import BackOrderDetailItem from "./views/BackOrderDetailItem"

export default BackOrderDetailItem
